import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
// import axios from "utils/axios";
import cookie from "utils/cookie";
import { get_userGetUserInfo } from "api/uaapi/user";

export default observer(function LayoutAuth({ needLogin, onAuthError, children }) {
  const router = useRouter();
  React.useEffect(() => {
    const token = cookie.get("token");
    const handleErr = () => {
      if (onAuthError) {
        onAuthError();
      } else {
        router.back();
      }
    };
    if (needLogin) {
      //必须用户已经登录
      if (!token) {
        handleErr();
      } else {
        // axios.instance.defaults.headers.token = token;
        // axios.instance.defaults.headers.Authorization = `Bearer ` + token;
        get_userGetUserInfo({
          noHandle401: true,
        })
          .then((userInfo) => {
            // appDispatch({ payload: { userInfo } });
            store.user.updateState({ userInfo });
          })
          .catch(() => {
            handleErr();
          });
      }
    } else {
      //必须用户没有登录
      if (token) {
        if (typeof location !== "undefined" && location.hostname === "localhost") return;
        // axios.instance.defaults.headers.token = token;
        // axios.instance.defaults.headers.Authorization = `Bearer ` + token;
        get_userGetUserInfo({
          noHandle401: true,
        })
          .then((userInfo) => {
            store.user.updateState({ userInfo });
            handleErr();
          })
          .catch(() => {
            cookie.remove("token");
          });
      }
    }
  }, []);

  return <>{children}</>;
});
